import { render, staticRenderFns } from "./SimulacaoFinalizarEnvio.vue?vue&type=template&id=1e6156d1"
import script from "./SimulacaoFinalizarEnvio.vue?vue&type=script&lang=js"
export * from "./SimulacaoFinalizarEnvio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports